import useGetScenarios from 'hooks/useGetScenarios';
import { useState } from 'react';

import ErrorMessage from './ErrorMessage';
import ScenarioItemSkeleton from './ScenarioItemSkeleton';
import { setHeaders } from './utils';
import './_simulation_styles.scss';

import ScenarioItem from './ScenarioItem';

const domain = import.meta.env.VITE_SIMULATION_ROUTE;

interface ScenariosListProps {
    selected: string | undefined;
    selectScenario(i: string): void;
}

const ScenariosList = ({}: ScenariosListProps) => {
    const [isDeletedScenario, setIsDeletedScenario] = useState<boolean>(false);
    const [isDeletedScenarioError, setIsDeletedScenarioError] = useState<boolean>(false);
    const { scenarios, isLoading, refresh } = useGetScenarios();

    const closeError = () => {
        setIsDeletedScenarioError(false);
    };

    // handleButtonAction(action, vin ) -> decide wich method will be called according to the action
    const deleteSimulation = async (id: string) => {
        const scenario = scenarios?.find(item => item.id === id);
        let url = '';
        if (scenario !== null && scenario !== undefined) {
            url = `${domain}/simulator-adapter-service/api/v1/scenario/${id}`;
        }
        setIsDeletedScenarioError(false);
        setIsDeletedScenario(true);
        try {
            await fetch(url, {
                method: 'DELETE',
                headers: await setHeaders(),
            });
        } catch (error) {
            setIsDeletedScenarioError(true);
            console.error(error);
        } finally {
            setIsDeletedScenario(false);
            refresh();
        }
    };

    return (
        <div className='ScenariosList'>
            {isDeletedScenarioError && (
                <ErrorMessage
                    message='Error while deleting scenario.'
                    onClose={closeError}
                    data-testid='delete-scenario-message'
                />
            )}
            {/* TODO - move the button bellow into TextButton component */}
            <button disabled={isLoading} onClick={refresh} className='ScenariosList__refresh-button'>
                Refresh list
            </button>
            {isLoading ? (
                <ScenarioItemSkeleton />
            ) : !scenarios?.length ? (
                <i className='ScenariosList__no-scenarios'>No scenario available</i>
            ) : (
                <ul className='ScenariosList__scenarios-list'>
                    {scenarios.map(_ => (
                        <li key={_.id} className='ScenariosList__scenario-item'>
                            <ScenarioItem
                                id={_.id}
                                name={_.name}
                                description={_.description}
                                scenarioContentKey={_.scenarioContentKey}
                                isLoading={isDeletedScenario}
                                onClick={deleteSimulation}
                            />
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default ScenariosList;
